import { useEffect, useState } from "react";
import { getWeatherEmoji, getWeatherLabel } from "../../utils/weatherCodes";

const CITIES = [
  { name: "Nueva York", timeZone: "America/New_York", lat: 40.7128, lon: -74.006 },
  { name: "California", timeZone: "America/Los_Angeles", lat: 34.0522, lon: -118.2437 },
  { name: "CDMX", timeZone: "America/Mexico_City", lat: 19.4326, lon: -99.1332 },
  { name: "Miami", timeZone: "America/New_York", lat: 25.7617, lon: -80.1918 },
  { name: "Chicago", timeZone: "America/Chicago", lat: 41.8781, lon: -87.6298 },
  { name: "Houston", timeZone: "America/Chicago", lat: 29.7604, lon: -95.3698 },
  { name: "Guadalajara", timeZone: "America/Mexico_City", lat: 20.6597, lon: -103.3496 },
  { name: "Madrid", timeZone: "Europe/Madrid", lat: 40.4168, lon: -3.7038 },
  { name: "Bogotá", timeZone: "America/Bogota", lat: 4.711, lon: -74.0721 },
  { name: "Buenos Aires", timeZone: "America/Argentina/Buenos_Aires", lat: -34.6037, lon: -58.3816 },
];

const formatCityTime = (timeZone) =>
  new Intl.DateTimeFormat("es-MX", {
    timeZone,
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(new Date());

export const useCityInfo = () => {
  const [cities, setCities] = useState(() =>
    CITIES.map((city) => ({ name: city.name, time: formatCityTime(city.timeZone) }))
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCities((prev) =>
        prev.map((city, i) => ({ ...city, time: formatCityTime(CITIES[i].timeZone) }))
      );
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    let cancelled = false;

    Promise.all(
      CITIES.map(async (city) => {
        try {
          const response = await fetch(
            `https://api.open-meteo.com/v1/forecast?latitude=${city.lat}&longitude=${city.lon}&current_weather=true`
          );
          const json = await response.json();

          return {
            name: city.name,
            temperature: Math.round(json.current_weather.temperature),
            label: getWeatherLabel(json.current_weather.weathercode),
            emoji: getWeatherEmoji(json.current_weather.weathercode),
          };
        } catch (err) {
          return null;
        }
      })
    ).then((results) => {
      if (cancelled) return;
      setCities((prev) =>
        prev.map((city) => {
          const weather = results.find((r) => r?.name === city.name);
          return weather ? { ...city, ...weather } : city;
        })
      );
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return cities;
};
